// extracted by mini-css-extract-plugin
export default {"root":"SignInForm_root__IE+r5","inputLink":"SignInForm_inputLink__rg8gb","after":"SignInForm_after__GPmyF"};